import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const  potonganService = {}

potonganService.data = function (token,data='') {
    return fetch({
        url: '/ref/potongan/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

potonganService.show = function (token,data='') {
    return fetch({
        url: '/ref/potongan/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

potonganService.data_import = function (token,data) {
    return fetch({
        url: '/ref/potongan/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

potonganService.empty_import = function (token,data) {
    return fetch({
        url: '/ref/potongan/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

potonganService.save_import = function (token,data) {
    return fetch({
        url: '/ref/potongan/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default potonganService;
